var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    viewBox: "0 -960 960 960",
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M257.565-102.804q-30.509 0-54.026-23.28-23.517-23.279-23.517-54.025v-569.5h-45.066v-77.304h208.218v-37.109h274.174v37.109h208.217v77.304H780.5v569.5q0 30.746-23.349 54.025-23.35 23.28-54.194 23.28H257.565ZM357-264.957h73.239v-401.804H357v401.804Zm174.522 0H605v-401.804h-73.478v401.804Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.190ae001cd24b82659fda01b084a75ca.svg";
export { ForwardRef as ReactComponent };